"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-11-03 13:50:35
 * @LastEditTime: 2022-02-22 10:22:15
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\constant\chart\visual-map.ts
 */
exports.default = {
    default: {
        calculable: false,
        orient: "horizontal",
        // text:[max,0],
        itemSymbol: "circle",
        itemWidth: 8,
        itemHeight: 8,
        left: "0",
        top: "0",
        color: ["#72DEB2 ", "#FFF36A", "#FF6E66"],
        pieces: [
            { lte: 2, color: "#8FEDB7" },
            { gt: 2, lte: 5, color: "#FFF36A" },
            { gt: 5, color: "#FF9185" } // (310, 1000]
        ],
        textStyle: {
            color: "#778493"
        }
    }
};
//# sourceMappingURL=visual-map.js.map